import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SearchIcon = () => (
  <SvgIcon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    style={{ 'fontSize': '16px' }}
  >
    <g>
      <path
        d="M11.4506834,10.5078744 L14.4714045,13.5285955 C14.731754,13.788945 14.731754,14.211055 14.4714045,14.4714045 C14.211055,14.731754 13.788945,14.731754 13.5285955,14.4714045 L10.5078744,11.4506834 C9.54301264,12.2121976 8.32457979,12.6666667 7,12.6666667 C3.87038642,12.6666667 1.33333333,10.1296136 1.33333333,7 C1.33333333,3.87038642 3.87038642,1.33333333 7,1.33333333 C10.1296136,1.33333333 12.6666667,3.87038642 12.6666667,7 C12.6666667,8.32457979 12.2121976,9.54301264 11.4506834,10.5078744 Z M10.1065048,10.0211634 C10.8657443,9.24061266 11.3333333,8.17491197 11.3333333,7 C11.3333333,4.60676608 9.39323392,2.66666667 7,2.66666667 C4.60676608,2.66666667 2.66666667,4.60676608 2.66666667,7 C2.66666667,9.39323392 4.60676608,11.3333333 7,11.3333333 C8.17491197,11.3333333 9.24061266,10.8657443 10.0211634,10.1065048 C10.0339573,10.0911888 10.0475458,10.076312 10.0619289,10.0619289 C10.076312,10.0475458 10.0911888,10.0339573 10.1065048,10.0211634 Z"
        id="path-1"
      />
    </g>
  </SvgIcon>
);

export default SearchIcon;
